import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PersonDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class PersonApiClient extends BaseCRUDApiClient<PersonDtoModel> {
  baseUrl = this.config.apiEndpoint + '/person';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
